import givefrontLogo from "../assets/brand/givefrontlogofull.png";

export function Pending() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-6 bg-background">
      <img
        src={givefrontLogo}
        alt="Givefront"
        className="h-16 w-auto animate-pulse opacity-90"
      />
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-muted border-t-primary" />
    </div>
  );
}
